import React, { useMemo } from 'react';
import { DataLayerGraphView } from '@/modules/shared/DataLayers';
import { fleetMostFrequentConfig } from '../dataLayerAdapters/FleetMostFrequentDataLayer';
import { useOperatorProficiency } from '@/contexts/OperatorProficiencyContext';

interface FleetMostFrequentCardProps {
  className?: string;
}

export const FleetMostFrequentCard: React.FC<FleetMostFrequentCardProps> = ({ className = '' }) => {
  const { listData, loading } = useOperatorProficiency();

  // Transform API data to component format
  // API returns: { alarmTypeId, alarmName, pctOfTotalAlarms }
  const abusesData = useMemo(() => {
    if (!listData || !Array.isArray(listData)) return { abuses: [] };

    const abuses = listData.map((item: any, index: number) => ({
      id: item.alarmTypeId || item.id || index.toString(),
      abuseName: item.alarmName || item.name || item.abuseName,
      count: item.count,
      percentage: item.pctOfTotalAlarms ?? item.percentage,
      tooltip: item.tooltip || item.alarmName,
    }));

    return { abuses };
  }, [listData]);

  return (
    <DataLayerGraphView
      graph={fleetMostFrequentConfig}
      data={abusesData}
      legendItems={[]}
      onLegendToggle={() => {}}
      loading={loading}
      className={className}
    />
  );
};
